<template>
    <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :close-on-backdrop="false"
        :centered="false" :title="title" :size="'lg'" :btn_cancel="true" :btn_ok="true" :booTitile="true">
        <div class="row d-flex mt-2">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-1">
                <label for="birthday" class="mb-1">Almacen<span style="color: red; font-weight: bold;">*</span></label>
                <select class="form-control" id="almacen" v-model="dataPost.almacen_id">
                    <option selected disabled :value=null>-- Seleccione --</option>
                    <option v-for="(item, index) in dataAlmacenes" :key="index" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-1">
                <label for="birthday" class="mb-1">Pisos<span style="color: red; font-weight: bold;">*</span></label>
                <select class="form-control" id="piso" v-model="dataPost.floor_id">
                    <option selected disabled :value=null>-- Seleccione --</option>
                    <option v-for="(item, index) in dataPisos" :key="index" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row d-flex mt-2">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-1">
                <label for="birthday" class="mb-1">Área<span style="color: red; font-weight: bold;">*</span></label>
                <select class="form-control" id="area" v-model="dataPost.area_id">
                    <option selected disabled :value=null>-- Seleccione --</option>
                    <option v-for="(item, index) in dataAreas" :key="index" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-1">
                <label for="birthday" class="mb-1">Lugar<span style="color: red; font-weight: bold;">*</span></label>
                <input type="text" placeholder="ingrese un lugar" class="form-control" v-model="dataPost.lugar">
            </div>
        </div>
        <template #footer>
            <button @click="mtdClose" class="btn btn-danger btn-sm">
                <i class="fa fa-times" />&nbsp;Cerrar
            </button>
            <button class="btn btn-success btn-sm" @click="mtd_action">
                Guardar
            </button>
            &nbsp;
        </template>
    </CModal>
</template>
<script>
import CModal from "@/components/shared/modals/CModal.vue";
import { mapActions } from "vuex";

export default {
    name: "c-movimientos-activos",
    components: {
        CModal
    },
    data() {
        return {
            dataPisos: [],
            dataAlmacenes: [],
            dataAreas: [],
            dataPost: {
                id: '',
                almacen_id: '',
                area_id: '',
                floor_id: '',
                lugar: ''
            }
        }
    },
    props: {
        title: String,
        boo_modal: Boolean,
        item: Object,
        activo_id: Number
    },
    watch: {
        boo_modal(newVal) {
            if (newVal == true) {
                this.mtdGetData();
            }
        },
        item: {
            handler(newVal) {
                if (newVal) {
                    this.dataPost = {
                        ...newVal
                    }
                }
            },
            immediate: true,
        }
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdClose() {
            this.$emit("closeModal");            
        },
        
        mtdGetData() {
            this.get({
                url: this.$store.getters.get__url + "/logistics/byData",
                token: this.$store.getters.get__token,
            }).then((response) => {
                this.dataAlmacenes = response.data.almacenes;
                this.dataPisos = response.data.pisos
                this.dataAreas = response.data.areas
            })
        },

        mtd_action() {
            // console.log(this.dataPost);
            this.post({
                url: this.$store.getters.get__url + "/logistics/updateLocation/" + this.activo_id + "/" + this.dataPost.id,
                token: this.$store.getters.get__token,
                params: this.dataPost
            }).then((response) => {
                if (response.statusCode == 200) {
                    Swal.fire({
                        title: "Movimiento registrado correctamente",
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#900052",
                    });
                    this.$emit("mtdDataEmit", this.activo_id);
                    this.mtdClose();
                }
            });
        }
    }
}
</script>